module.exports = __webpack_public_path__ + "img/photo-9.30fae94f.webp";